import React, { useCallback, useEffect, useMemo, useRef, useState } from "react"
import {ClipLoader} from 'react-spinners'
import n0 from './wingoimg/0.png'
import n1 from './wingoimg/1.png'
import n2 from './wingoimg/2.png'
import n3 from './wingoimg/3.png'
import n4 from './wingoimg/4.png'
import n5 from './wingoimg/5.png'
import n6 from './wingoimg/6.png'
import n7 from './wingoimg/7.png' 
import n8 from './wingoimg/8.png'
import n9 from './wingoimg/9.png'

import b1 from './k3img/b1.png'
import b2 from './k3img/b2.png'
import b3 from './k3img/b3.png'
import b4 from './k3img/b4.png'
import b5 from './k3img/b5.png'
import b6 from './k3img/b6.png' 

import kn1 from './k3img/n1.png'
import kn2 from './k3img/n2.png'
import kn3 from './k3img/n3.png'
import kn4 from './k3img/n4.png'
import kn5 from './k3img/n5.png'
import kn6 from './k3img/n6.png'

import expert_item_bg from './img/expert_item_bg.svg'
import expert_profile_bg from './img/expert_profile_bg.svg'
import FlipNumbers from "react-flip-numbers"
import profile from './img/profile.jpg'
import { Spin, Tag } from "antd"
import { useTranslation } from "react-i18next"
import useDrawResult, { hit, useCurrentGame } from "../../hooks/useDraw"
import { TbTargetArrow, TbTargetOff } from "react-icons/tb"
import theme from "../../theme"
import {blue} from "../../theme/colors"
import { PlanType, base, useLatestPlan, useLatestPlanNPlanHistory, usePlanHistories, usePlanners } from "../../hooks/usePlanners"
import { useHistory } from "react-router"
import { getNextIssueNumber } from "../../utils/util"
import { useCountdown } from "../../hooks/useCountdown"
import sleep from "sleep-promise"
import Spacer from "../../components/Spacer"
 
export const WinGoPlan:React.FC<{gameType:string,gamePath:string}> = ({gameType,gamePath})=>{
  const {planners,loadingStatus:loadingPlanner} = usePlanners() 
  const gamePrefix = useMemo(()=>{
   return gamePath.split('_')[0]
  },[gamePath])
        
  const history = useHistory() 

  const [numbers,setNumbers] = useState<string>('')
  const numberRef = useRef<string>('73464')
  const intervalRef = useRef<NodeJS.Timeout>()
  const {t} = useTranslation()
 
 
  // const {typeId}:{typeId:string} = useParams()
  const pids = useMemo(()=>{
    // @ts-ignore
    return planners?.map(p=>p.pid)
  },[planners])  
  const planTypes = useMemo(()=>{
    if(gamePrefix === 'WinGo' || gamePrefix === 'TrxWinGo'){
      return [
        {name:t('B/S'),id:'bs'},
        {name:t('Color'),id:'oe'},
        // {name:t('Co'),id:'oe'},
        {name:`5 ${t('Nums')}`,id:'5'},
        {name:`7 ${t('Nums')}`,id:'7'},
        // {name:`8 ${t('Nums')}`,id:'8'},
      ]
    }
    return  [
      {name:t('Big Small'),id:'bs'},
      {name:t('Odd Even'),id:'oe'},
    ]
  },[gamePrefix])
  const [selectedPlanType,setSelectedPlanType] = useState<{name:string,id:string}>()
  
  const tab = useMemo(()=>{
    if(!gamePrefix){
      return 
    } 
    return {path: gamePath,title:'',minute:'',type:0}
  },[gamePath])
  const {drawResult,refreshDrawResult} = useDrawResult(tab)
  
  useEffect(()=>{
    setSelectedPlanType(planTypes[0])
  },[gamePrefix])
  
  const latestIssueNumber = useMemo(()=>{
    return getNextIssueNumber(parseInt(gameType))
  },[drawResult,selectedPlanType,gameType])
  const {sortedLatestPlans,refreshLatestPlan,loadPlanHistories,hitProfiles} = useLatestPlanNPlanHistory(gamePrefix,gameType,latestIssueNumber,null,selectedPlanType?.id) 
  const refreshPlanCallback = useCallback(()=>{   
    loadPlanHistories()
    refreshLatestPlan()
  },[loadPlanHistories,refreshLatestPlan]) 
  const [countDown] = useCountdown(parseInt(gameType), drawResult,refreshPlanCallback);
  console.log('gameType',gameType,drawResult,countDown)
  const reversedHitTrends = useMemo(()=>{
    try{
      console.log('hitProfiles',hitProfiles)
      return hitProfiles?.map((profile:any)=>{
        return [...profile.hitTrend].reverse() || []
      }) 
    }catch(e){
      console.error('e',e)
    }
    return []
  },[hitProfiles])
 
  // @ts-ignore
  // useCountdown('1',drawResult?.issueNumber || 0,refreshDrawResultCallback)
  // const [open,setOpen] = useState(false)
  const hitFont = useMemo(()=>{
    if(document.body.clientWidth>400){
      return 15
    }else{
      return 12
    }
  },[])
  return (
    <div style={{padding:10,background:'#F9F9F9',width:'100%',paddingTop:0}}>
      <div style={{background:'white',width:'100%',borderRadius:10, boxShadow:'0px 4px 6px rgba(11, 24, 50, 0.12)',display:'flex',flexDirection:'column',alignItems:'center',minHeight:'100vh'}}>
        {/* {gamePath} */}
        <div style={{display:'flex',flexDirection:'row',width:'100%',padding:10,paddingRight:10}}>
        {planTypes.map((type,index,arr)=>{ 
          return <>
            <div style={{fontWeight:'bold',fontSize:16,borderWidth:1,borderColor:selectedPlanType === type?blue[900]:'transparent', color:selectedPlanType === type? blue[900]:'#646C7B',background:selectedPlanType === type? blue[100]:'#F3F3F3',flex:1,padding:5, borderRadius:10,textAlign:'center'}} onClick={()=>setSelectedPlanType(planTypes[index])}>{type.name}</div>
            {index!=arr.length-1 && <Spacer size="sm"/>}
          </>
        })}
        </div>
        {/* {hitProfiles?.length} */}
        {/* {JSON.stringify(hitProfiles)} */}
        {(hitProfiles||[]).map(({planner},index:number)=>{
          return <div style={{display:'flex',marginBottom:10,width:'calc(100% - 20px)',position:'relative'}} onClick={()=>{
            window.open(`#/plan_detail/${gamePrefix}_${gameType}_${planner.pid}_${selectedPlanType.id}`,'_blank')
          }}>
           
              <img src={expert_item_bg} style={{width:'100%',aspectRatio:350/84}}/>
              <div style={{position:'absolute',left:0,right:0,top:0,bottom:0,display:'flex',flexDirection:'row',fontSize:14}}>
                  <div style={{display:'flex',flexDirection:'column',alignItems:'center',width:'17%',justifyContent:'space-between'}}>
                    <div  style={{width:'100%',height:'100%',position:'relative'}}>
                      <img src={expert_profile_bg} style={{width:'100%'}}/>
                      <img src={base+'avatar/'+ planner.pid?.replace('planner','')+'.jpeg' } style={{position:'absolute',left:'10%',top:'9%',objectFit:'cover', width:'80%',aspectRatio:'1/1',borderRadius:30}}/>  
                    </div>
                    
                    
                    <span style={{textOverflow:'ellipsis',overflow:'hidden',whiteSpace:'nowrap',fontSize:12,marginBottom:5}}>{planner.plannerName}</span>
                  </div>
                  <div style={{  flex:1,marginLeft:20,justifyContent:'space-around',paddingTop:'2.5%',display:'flex',flexDirection:'column'}}>
                    <div>{t('Hit Rate')}:{hitProfiles?.[index]?.hitRate}</div>
                    <div style={{display:'flex',alignItems:'center'}}>{t('Trend')}: {reversedHitTrends?.[index]?.map((h:boolean,i:number,arr:boolean[])=><>
                      {/* <span style={{color:h? theme.color.primary.main:'#ddd' }}>{t('Hit')}</span>  */}
                      {h ?<TbTargetArrow style={{fontSize:hitFont,color:theme.color.primary.main,fontWeight:'thin'}}/>:
                            <TbTargetOff style={{fontSize:hitFont,color:'#bbb',fontWeight:'thin'}}/>}
                      {i!==arr.length-1 &&<span style={{color:'#aaa',fontWeight:'bold',marginLeft:1,marginRight:1,fontSize:10}}>{'<'}</span>} 
                    </>)}</div> 
                    <div style={{display:'flex',alignItems:'center'}}>
                    {t('Plan')} <span style={{width:5}}/>
                        {
                        sortedLatestPlans?.[index]?.content.bs? 
                          <span style={{marginLeft:10,color:'white', borderRadius:20,background:theme.color.primary.main,paddingLeft:10,paddingRight:10, height:20,display:'flex',alignItems:'center',justifyContent:'center'}}>
                            {sortedLatestPlans?.[index]?.content.bs==='b'?t('Big'):t('Small')}
                          </span>:
                            (sortedLatestPlans?.[index]?.content.oe? 
                              (
                                (gamePrefix === 'WinGo'|| gamePrefix === 'TrxWinGo') ?
                                <span style={{background:sortedLatestPlans?.[index]?.content.oe==='o'?'green':'red',width:20,height:20,borderRadius:10}}/>:
                              <span style={{marginLeft:10,color:'white', borderRadius:20,background:theme.color.primary.main,paddingLeft:10,paddingRight:10, height:20,display:'flex',alignItems:'center',justifyContent:'center'}}>
                                {sortedLatestPlans?.[index]?.content.oe==='o'?
                                  t('Odd') :
                                  t('Even')
                                }
                              </span>):

                              sortedLatestPlans?.[index]?.content.numbers.map((num:any)=>{
                                return <span style={{marginRight:5,color:'white', borderRadius:20,background:theme.color.primary.main,width:20,height:20,display:'flex',alignItems:'center',justifyContent:'center'}}>
                                {num}
                              </span>
                            }))
                        }
                      </div>
                  </div>
            </div>
           
          </div>
        })}
        {loadingPlanner && <>
          <Spin/>
        </>}
      </div> 
      </div>
  );
}

export const K3Plan:React.FC<{historyDrawResult:any}> = ({historyDrawResult})=>{
  const lotteryPics = useMemo(()=>{
    return [kn1,kn2,kn3,kn4,kn5,kn6];
  },[])

  const {t} = useTranslation()
  return <>
  <div style={{background:'transparent',display:'flex',flexDirection:'row',borderTopLeftRadius:10,borderTopRightRadius:10,padding:0,paddingTop:10,paddingBottom:10,marginTop:10,width:'calc(100% - 20px)'}}>
            <div style={{flex:2,color:'black',textAlign:'center' }}>
              {t('Period')}
            </div>
            <div style={{flex:1,color:'black',textAlign:'center' }}>
              {t('Sum')}
            </div>
            <div style={{flex:1,color:'black',textAlign:'center' }}>
            {t('B/S')}
            </div>
            {/* <div style={{flex:1,color:'white',textAlign:'center',fontWeight:'bold'}}>
              O/E
            </div> */}
            <div style={{flex:2,color:'black',textAlign:'center' }}>
              {t('Number')}
            </div>
          </div>
          {historyDrawResult.map((item:any)=>{
            if(!item){
              return <></>
            }
            const number = parseInt(item.content?.number)
            const plan = item.plan 
            const hits = hit(item)
            // if(plan && item.content){
            //     if(plan.content.bs === 'b' && item.content.sumCount>9){
            //       bshit = true
            //     }
            //     if(plan.content.bs === 's' && item.content.sumCount<=9){
            //       bshit = true
            //     }
            // }
            // let oehit = false
            // if(plan && item.content){
            //     if(plan.content.oe === 'e' && item.content.sumCount%2){
            //       oehit = true
            //     }
            // }
            return  <div style={{background:'white',display:'flex',flexDirection:'row',flex:1,position:'relative',padding:0,width:'calc(100% - 20px)'}}>
            <div style={{flex:2,color:'black',textAlign:'center',display:'flex',alignItems:'center',justifyContent:'center',paddingLeft:10}}>
              {item.issueNumber}
            </div>
            <div style={{flex:1,color:'white',textAlign:'center',fontWeight:'bold',display:'flex',alignItems:'center',justifyContent:'center'}}>
              <span style={{color:item.content?.sumCount%2?'green':'orange',fontWeight:'bold',fontSize:item.content?30:10}}>{item.content?item.content.sumCount:''}</span>
            </div>
            <div style={{flex:1,color:'black',textAlign:'center',display:'flex',alignItems:'center',justifyContent:'center',flexDirection:'column',padding:item.content?0:10}}>
              <span>{!item.content?t('Pending'):(item.content.sumCount>9?t('Big'):t('Small'))}
              {hits && <span style={{color:'white',fontSize:10,background:'red',borderRadius:2,paddingLeft:2,paddingRight:2,marginLeft:2}} >Hit</span>}
              </span>
              {plan && <span style={{fontSize:10}}>Plan:{plan.content.bs==='b'?t('Big'):t('Small')}</span>}
              {/* {JSON.stringify(item)} */}
            </div>
            {/* <div style={{flex:1,color:'black',textAlign:'center',display:'flex',flexDirection:'column', alignItems:'center',justifyContent:'center'}}>
              <span>{!item.content?'':(item.content.sumCount%2?'Odd':'Even')}
              {plan && <span style={{color:oehit?'red':'gray',fontSize:10}} >{oehit?'Hit':'Miss'}</span>}
              </span>
              {plan && <span style={{fontSize:10}}>{plan.content.oe=='o'?'Plan:Odd':'Plan:Even'}</span>}
            </div> */}
            <div style={{flex:2,color:'black',textAlign:'center',fontWeight:'normal',display:'flex',alignItems:'center',justifyContent:'center'}}>
              {!item.content?'':item.content.premium.split('').map((num:string)=>{
                return <img src={lotteryPics[parseInt(num)-1]} style={{width:20,height:20,marginLeft:10}} alt=''/>
              })}
            </div>
            <div style={{position:'absolute',left:0,right:0,bottom:0,height:1,background:'#efefef'}}/>
          </div>
          })}
  </>
}

export const _5DPlan:React.FC<{historyDrawResult:any}> = ({historyDrawResult,})=>{
  const {t} = useTranslation()
  return <>
      <div style={{background:'transparent',display:'flex',flexDirection:'row',borderTopLeftRadius:10,borderTopRightRadius:10,padding:0,paddingTop:10,paddingBottom:10,width:'calc(100% - 20px)',marginTop:10}}>
                <div style={{flex:2,color:'black',textAlign:'center' }}>
                  {t('Period')}
                </div>
              
                <div style={{flex:2,color:'black',textAlign:'center' }}>
                {t('Number')}
                </div>
                <div style={{flex:1,color:'black',textAlign:'center' }}>
                {t('Sum')}
                </div>
                <div style={{flex:1,color:'black',textAlign:'center'}}>
                  {t('B/S')}
                </div>
                {/* <div style={{flex:1,color:'white',textAlign:'center',fontWeight:'bold'}}>
                  O/E
                </div> */}
              </div>
              {historyDrawResult.map((item:any)=>{
                if(!item){
                  return <></>
                }
                // const number = parseInt(item.content.number)
                const plan = item.plan;
                const hits = hit(item);
                return  <div style={{background:'white',display:'flex',flexDirection:'row',flex:1,position:'relative',padding:0,paddingTop:10,paddingBottom:10,width:'calc(100% - 20px)'}}>
                <div style={{flex:2,color:'black',textAlign:'center',display:'flex',alignItems:'center',justifyContent:'center',paddingLeft:10}}>
                  {'**'+item.issueNumber.substring(6,16)}
                </div>
              
                <div style={{flex:2,textAlign:'center',display:'flex',alignItems:'center',justifyContent:'center'}}>
                  {!item.content? t('Pending'): item.content.premium.split('').map((num:string)=>{
                    return <div style={{borderRadius:50,color:'black',border:'1px solid #121212',width:20,height:20,display:'flex',alignItems:'center',justifyContent:'center',marginRight:5}}>{num}</div>
                  })}
                </div>
                <div style={{flex:1,color:'black',textAlign:'center',display:'flex',alignItems:'center',justifyContent:'center'}}>
                  {!item.content? '':item.content.sumCount}
                </div>
                <div style={{flex:1,color:'black',textAlign:'center',display:'flex',alignItems:'center',justifyContent:'center',flexDirection:'column'}}>
                <span>{!item.content?t('Pending'):(item.content.sumCount>22?t('Big'):t('Small'))}
                {hits && <span style={{color:'white',fontSize:10,background:'red',borderRadius:2,paddingLeft:2,paddingRight:2,marginLeft:2}} >Hit</span>}
              </span>
                  {plan && <span style={{fontSize:10}}>Plan:{plan.content.bs==='b'?t('Big'):t('Small')}</span>}
                </div>
                {/* <div style={{flex:1,color:'black',textAlign:'center',display:'flex',alignItems:'center',justifyContent:'center'}}>
                  {!item.content? '':item.content.sumCount%2?'Even':'Odd'}
                </div> */}
                <div style={{position:'absolute',left:0,right:0,bottom:0,height:1,background:'#efefef'}}/>
              </div>
              })}
  </>
} 

export const TrxWingoPlan:React.FC<{historyDrawResult:any[]}> = ({historyDrawResult})=>{
  const {t} = useTranslation()
  return <>
        <div style={{background:'transparent',display:'flex',flexDirection:'row',borderTopLeftRadius:10,borderTopRightRadius:10,padding:10,width:'calc( 100% - 20px)',marginTop:10}}>
          <div style={{flex:2,color:'black',textAlign:'center'}}>
            {t('Period')}
          </div>
          <div style={{flex:1,color:'black',textAlign:'center' }}>
            {t('Block')}
          </div>
          <div style={{flex:1,color:'black',textAlign:'center' }}>
            {t('Time')}
          </div>
          <div style={{flex:1,color:'black',textAlign:'center' }}>
            {t('Hash')}
          </div>
          <div style={{flex:1,color:'black',textAlign:'center' }}>
            {t('Result')}
          </div>
        </div>
        {historyDrawResult.map((item:any)=>{
          if(!item){
            return <></>
          }
          const number = parseInt(item.content?.number) 
          const plan = item.plan
          const hits = hit(item)
          return  <div style={{background:'white',display:'flex',flexDirection:'row',flex:1,position:'relative',padding:0,fontSize:14,paddingTop:10,paddingBottom:10,width:'calc( 100% - 20px)'}}>
          <div style={{flex:2,color:'black',textAlign:'center',display:'flex',alignItems:'center',justifyContent:'center'}}>
            **{item.issueNumber.substring(7,16)}
          </div>
          <div style={{flex:1,color:'white',textAlign:'center',fontWeight:'bold',display:'flex',alignItems:'center',justifyContent:'center'}}>
            <span style={{color:'black',fontWeight:'normal', }}>{!item.content?'Pending':item.content.blockNumber}</span>
          </div>
          <div style={{flex:1,color:'white',textAlign:'center',fontWeight:'bold',display:'flex',alignItems:'center',justifyContent:'center'}}>
            <span style={{color:'black',fontWeight:'normal'}}>{!item.content?'':item.content.blockTime?.split(' ')[1]}</span>
          </div>
          <div style={{flex:1,color:'white',textAlign:'center',fontWeight:'bold',display:'flex',alignItems:'center',justifyContent:'center'}}>
            <span style={{color:'black',fontWeight:'normal'}}>{!item.content?'':('**'+item.content.blockID.substring(59,64))}</span>
          </div>
          <div style={{flex:1,color:'black',textAlign:'center',display:'flex',alignItems:'center',justifyContent:'center',flexDirection:'column'}}>
              <span>
                {!item.content? t('Pending') : (number>=5?t('Big'):t('Small')) }
                {hits && <span style={{color:'white',fontSize:10,background:'red',borderRadius:2,paddingLeft:2,paddingRight:2,marginLeft:2}} >{hits?'Hit':''}</span>}
              </span>
              {plan && <span style={{fontSize:10}}>Plan:{plan.content.bs=='b'?t('Big'):t('Small')}</span>}
          </div>
        
          <div style={{position:'absolute',left:0,right:0,bottom:0,height:1,background:'#efefef'}}/>
        </div>
      })}
    </>
} 

const LotteryPlan:React.FC<{gameType:string,gamePath:string}> = ({gameType,gamePath})=>{
  const game = useCurrentGame()
  if(!game){
    return <></>
  }
  // if(historyDrawResult){
  //   // console.log('historyDrawResult[0]',historyDrawResult[1])
  //   if(historyDrawResult.length===0 || historyDrawResult[1].lottery?.toLowerCase() !== game){
  //       return <ClipLoader color='white' size={30} />
  //   }
  // }
  // if(game === 'wingo'){
    return <WinGoPlan gameType={gameType} gamePath={gamePath}/>
  // }
  // return <></>
  // if(game === 'k3'){
  //   return <K3Plan/>
  // }
  // if(game === '5d'){
  //   // @ts-ignore
  //   return <_5DPlan/>
  // }
  // if(game === 'trxwingo'){
  //   return <TrxWingoPlan/>
  // }
       
}

export default LotteryPlan;